(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("scroller", [], factory);
	else if(typeof exports === 'object')
		exports["scroller"] = factory();
	else
		root["scroller"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 